import React, { memo, useMemo, useEffect, useState } from 'react'
import { Form, Skeleton } from 'antd'
import { VStack, HStack } from '../../../../../ui/Stack'
import { DefaultJsonForm } from '../../../../../components/v2/default-json-form'
import { EmployeeFormData } from '../../types/types'

interface EmployeeViewFormProps {
  formData: EmployeeFormData | null
  loading: boolean
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
}

export const EmployeeViewForm: React.FC<EmployeeViewFormProps> = memo(
  (props: EmployeeViewFormProps) => {
    const { formData, loading } = props
    const [form] = Form.useForm()
    const [localFormData, setLocalFormData] = useState<any>(null)

    useEffect(() => {
      if (formData?.formData) {
        const initialFormData = formData.formData || {}
        setLocalFormData(initialFormData)
        form.setFieldsValue(initialFormData)
      }
    }, [formData, form])

    const viewSchema = useMemo(() => {
      if (!formData?.schema) {
        return { type: 'object', properties: {}, required: [] }
      }

      const schema = JSON.parse(JSON.stringify(formData.schema))

      if (schema.properties) {
        Object.keys(schema.properties).forEach(key => {
          if (!schema.properties[key].options) {
            schema.properties[key].options = {}
          }
          schema.properties[key].options.disabled = true
          schema.properties[key].options.readOnly = true
        })
      }

      return schema
    }, [formData?.schema])

    if (loading) {
      return <Skeleton active />
    }

    if (!formData || !formData.schema) {
      return (
        <HStack gap={'8'} className={'mapWrapper'}>
          Нет доступных полей для отображения. Проверьте права доступа.
        </HStack>
      )
    }

    const schema = viewSchema

    if (!schema || !schema.properties || Object.keys(schema.properties).length === 0) {
      return (
        <HStack gap={'8'} className={'mapWrapper'}>
          Нет доступных полей для отображения. Проверьте права доступа.
        </HStack>
      )
    }

    return (
      <HStack gap={'8'} max>
        <Form
          {...formItemLayout}
          layout="horizontal"
          form={form}
          scrollToFirstError={true}
          style={{ width: '100%' }}
        >
          {!loading ? (
            <VStack gap={'16'} max align={'stretch'} className={'employeeForm'}>
              {formData &&
                schema &&
                schema.properties &&
                Object.keys(schema.properties).length > 0 && (
                  <DefaultJsonForm
                    formData={localFormData || {}}
                    schema={schema}
                    orientation="horizontal"
                  />
                )}
            </VStack>
          ) : (
            <Skeleton active />
          )}
        </Form>
      </HStack>
    )
  },
)

EmployeeViewForm.displayName = 'EmployeeViewForm'
